import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWifi = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={51} height={44} fill='none' {...props}>
    <g clipPath='url(#wifi_svg__a)'>
      <path
        fill='#F23645'
        d='M50.698 10.26c-.06.62-.135 1.236-.175 1.857-.379 5.882-.75 11.765-1.126 17.648-.035.553-.082 1.105-.125 1.677h-6.866L40.99 9.473h9.708v.789'
      />
      <path
        fill='var(--blue-1-active)'
        d='m37.708 6.406.336 5.34C26.486 8.19 16.258 10.41 7.377 18.586L.302 11.513C12.382-1.126 33.677-4.143 49.605 6.406zM11.267 23.17c2.226-2.31 4.757-4.08 7.659-5.279 6.051-2.5 12.129-2.515 18.203-.053 1.382.56 1.36.564 1.448 2.064q.236 4.033.52 8.062c.024.334-.07.55-.297.774-.43.425-.83.878-1.27 1.35-2.722-2.632-5.894-3.962-9.575-3.922-3.662.039-6.796 1.416-9.409 4.039zM28.08 44c-3.19-.009-5.77-2.595-5.762-5.775.008-3.168 2.622-5.77 5.79-5.76 3.16.011 5.747 2.593 5.745 5.738-.003 3.243-2.556 5.805-5.774 5.797'
      />
      <path
        fill='#F23645'
        d='M50.038 39.223a4.185 4.185 0 0 1-4.194 4.194c-2.321-.009-4.22-1.902-4.208-4.195.012-2.308 1.908-4.201 4.21-4.205s4.193 1.894 4.192 4.206'
      />
    </g>
    <defs>
      <clipPath id='wifi_svg__a'>
        <path fill='#fff' d='M.302 0h50.396v44H.302z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWifi;
